import LazyHydrate from 'react-lazy-hydration'

/**
 * @deprecated as of Next.js version 15 and above
 */
export default LazyHydrate
